var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_581_2110)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.83834 0.41C9.70834 0.16 9.44834 0.01 9.17834 0H6.69834C6.28834 0 5.94834 0.34 5.94834 0.75C5.94834 1.16 6.28834 1.5 6.69834 1.5H7.72834L5.92834 4.04C5.68834 4.38 5.76834 4.85 6.10834 5.09C6.23834 5.18 6.38834 5.23 6.54834 5.23H9.33834C9.74834 5.23 10.0883 4.89 10.0883 4.48C10.0883 4.07 9.74834 3.73 9.33834 3.73H7.99834L9.79834 1.19C9.95834 0.96 9.97834 0.66 9.84834 0.41H9.83834ZM4.22834 4.06C4.09834 3.81 3.83834 3.65 3.55834 3.65H0.918344C0.508344 3.65 0.168344 3.99 0.168344 4.4C0.168344 4.81 0.508344 5.15 0.918344 5.15H2.11834L0.138344 7.94C-0.101656 8.28 -0.0216563 8.75 0.318344 8.99C0.448344 9.08 0.598344 9.13 0.748344 9.13H3.72834C4.13834 9.13 4.47834 8.79 4.47834 8.38C4.47834 7.97 4.13834 7.63 3.72834 7.63H2.19834L4.17834 4.84C4.33834 4.61 4.35834 4.31 4.22834 4.06ZM10.3383 7.07C10.7483 7.07 11.0883 7.41 11.0883 7.82C11.0883 7.98 11.0383 8.13 10.9483 8.25L7.94834 12.48H10.5583C10.9683 12.48 11.3083 12.82 11.3083 13.23C11.3083 13.64 10.9683 13.98 10.5583 13.98H6.49834C6.08834 13.98 5.74834 13.64 5.74834 13.23C5.74834 13.08 5.79834 12.92 5.88834 12.8L8.88834 8.57H6.72834C6.31834 8.57 5.97834 8.23 5.97834 7.82C5.97834 7.41 6.31834 7.07 6.72834 7.07H10.3383Z",
    fill: "#4A57DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_581_2110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.32,
    height: 13.98,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSleep);
export default __webpack_public_path__ + "static/media/active-sleep.277be399d928c3262ce1c7bec1f55a38.svg";
export { ForwardRef as ReactComponent };